import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { StyledBaseLayout, StyledCells } from "./BaseLayout.style";

export type BaseLayoutProps = {
  primary?: boolean;
  secondary?: boolean;
  children?: React.ReactNode;
  showCells?: boolean;
  withScrollRestoration?: boolean;
  showHeader?: boolean;
  showFooter?: boolean;
};

function BaseLayout({
  primary,
  secondary,
  children,
  showCells = false,
  withScrollRestoration = true,
  showHeader = false,
  showFooter = false,
}: BaseLayoutProps) {
  const location = useLocation();
  const previousPathname = useRef<string>();

  useEffect(() => {
    if (!withScrollRestoration) return;

    if (location.pathname !== previousPathname.current) {
      window.scrollTo(0, 0);
    }

    previousPathname.current = location.pathname;
  }, [location.pathname, withScrollRestoration]);

  return (
    <StyledBaseLayout
      data-primary={primary}
      data-secondary={secondary}
      data-testid="baseLayout"
    >
      {children}
      {showCells && <StyledCells />}
    </StyledBaseLayout>
  );
}

export { BaseLayout };
